import { render } from "./ClassificationForm.vue?vue&type=template&id=782767be&ts=true"
import script from "./ClassificationForm.vue?vue&type=script&lang=ts"
export * from "./ClassificationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__